import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { useDispatch } from "react-redux";
import {
  Divider,
  Form,
  Input,
  Row,
  Col,
  Button,
  Spin,
  message,
  Select,
  InputNumber,
} from "antd";
import map from "lodash/map";

import ImageUpload from "../../common/imageUpload";
import {
  createCompanyParts,
  updateCompanyParts,
} from "../../redux/actions/companyActions";
import { ADD_PART_SUCCESS, UPDATE_PART_SUCCESS } from "../../constants/message";
import PartMetaInputs from "./partMetaInputs";

const PartForm = ({
  toggle,
  onSuccess,
  initialValue,
  filter,
}) => {
  const dispatch = useDispatch();
  const isEdit = get(initialValue, "name") ? true : false;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const updatePart = (payload) => {
    setLoading(true);
    dispatch(
      updateCompanyParts(
        get(initialValue, "id"),
        get(filter, "company.id"),
        payload
      )).then(() => {
        setLoading(false);
        message.success(UPDATE_PART_SUCCESS);
        onSuccess();
      }).catch(() => {
        setLoading(false)
      });
  };

  const createPart = (payload) => {
    setLoading(true);
    dispatch(createCompanyParts(get(filter, "company.id"), payload))
      .then(() => {
        setLoading(false);
        message.success(ADD_PART_SUCCESS);
        onSuccess();
      }).catch(() => {
        setLoading(false)
      });
  };

  const onFinish = (values) => {
    const payload = {
      ...values,
      company: get(filter, "company.id"),
      type: get(filter, "templateType"),
      image: get(logoImage, "key"),
    };
    if (isEdit) {
      updatePart(payload);
    } else {
      createPart(payload);
    }
  };
  const [logoImage, setLogoImage] = useState(
    isEdit ? get(initialValue, "image") : { key: null, url: null }
  );
  
  useEffect(()=>{
    if(get(filter, "templateType") === 3){
      form.setFieldValue(['meta', "press_cycle"],get(initialValue,"meta.press_cycle",1))
    }
    if(get(filter, "templateType") !== 2){
      form.setFieldValue(['meta', "units_per_box"],get(initialValue,"meta.units_per_box",1))
    }
  },[initialValue])

  return (
    <Spin spinning={loading}>
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        onFinishFailed={() => { }}
        initialValues={initialValue}
      >
            <Divider orientation="left">General</Divider>
        <Row gutter={16}>
          <Col xs={24} md={18}>
            <Row gutter={16}>
              <Col md={6} xs={24}>
                <Form.Item name={"company"} label={`Company`}>
                  <Select
                    options={map([get(filter, "company")], (company) => ({
                      label: get(company, "name"),
                      value: get(company, "id"),
                    }))}
                    defaultValue={get(filter, "company.id")}
                    placeholder="Company"
                    size="small"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item name={"template_type"} label={`Template Type`}>
                  <Select
                    options={map(
                      get(filter, "company.template_access_list"),
                      (templateType) => ({
                        label: get(templateType, "name"),
                        value: get(templateType, "value"),
                      })
                    )}
                    defaultValue={get(filter, "templateType")}
                    placeholder="Template Type"
                    disabled={true}
                    size="small"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item name={"item_id"} label={`Item Id`}>
                  <Input style={{ width: "100%" }} placeholder="Item Id" size="small" />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  name={"name"}
                  label={`Part Name`}
                  rules={[{ required: true, message: "Part name is required" }]}
                >
                  <Input placeholder="Part Name" size="small" />
                </Form.Item>
              </Col>
              <PartMetaInputs
                templateType={get(filter, "templateType")}
                form={form}
              />

            </Row>
           
          </Col>
          <Col xs={24} md={6} className="flex justify-end items-start">
            <Form.Item name={"logo"} label={`Part Image`}>
              <ImageUpload
                onUploadDone={(imageObj) => {
                  setLogoImage(imageObj);
                  form.setFieldsValue({
                    ...form.getFieldsValue(),
                    logo: imageObj,
                  });
                }}
                imageUrl={get(logoImage, "url")}
                size="small"
              />
            </Form.Item>
          </Col>
        </Row>
        <div className="w-full bg-white p-4">
           <Divider orientation="left">Costings</Divider>
            <Row gutter={16}>
              <Col md={6} xs={24}>
                <Form.Item name={['meta','costings', "job_cost_per_pc"]} label="Job Cost" >
                  <InputNumber placeholder="Job Cost"
                    prefix="₹"
                    style={{ width: "100%" }} size="small"
                  />
                </Form.Item>
              </Col>
              <Col md={6} xs={24}>
                <Form.Item name={['meta','costings', "contractual_cost_per_pc"]} label="Contratual Cost">
                  <InputNumber placeholder="Contratual Cost"
                    prefix="₹"
                    style={{ width: "100%" }} size="small"
                  />
                </Form.Item>
              </Col>
              <Col md={6} xs={24}>
                <Form.Item name={['meta', 'costings',"profit_per_pc"]} label="Profit Cost">
                  <InputNumber placeholder="Profit Cost"
                    prefix="₹"
                    style={{ width: "100%" }} size="small"
                  />
                </Form.Item>
              </Col>
            </Row>
          <div className="flex justify-end space-x-2">
            <Button
              onClick={() => {
                toggle();
              }}
              className="border-gray-300"
            >
              Close
            </Button>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </div>
        </div>
      </Form>
    </Spin>
  );
};
export default PartForm;
